import { Record, List } from "immutable";
import Element from "./element";

const defaults = {
    key: undefined,
    elements: List,
};

class SectionRecord extends Record(defaults) {
    constructor(args = {}) {
        super(
            Object.assign({}, args, {
                elements: List(args.elements && args.elements.map((val) => new Element(val))),
            })
        );
    }
}

export default SectionRecord;
